import { supabase } from './supabase';
import { auditLogService } from './auditLog';

export const competitionAccessService = {
  async getUserRole(competitionId) {
    const { data: { user } } = await supabase.auth.getUser();
    const userId = user?.id;
    if (!userId) return null;
    
    const { data: access, error } = await supabase
      .from('competition_access')
      .select('role')
      .match({ competition_id: competitionId, user_id: userId })
      .limit(1)
      .maybeSingle();

    if (error) {
      console.error('Error getting user role:', error);
      return null;
    }

    return access?.role;
  },

  async getAllUserAccess() {
    const { data: { user } } = await supabase.auth.getUser();
    const userId = user?.id;
    if (!userId) return {};
    
    const { data: access, error } = await supabase
      .from('competition_access')
      .select('competition_id, role')
      .match({ user_id: userId })
      .limit(100);

    if (error) {
      console.error('Error getting user access:', error);
      return {};
    }

    return access.reduce((acc, curr) => {
      acc[curr.competition_id] = curr.role;
      return acc;
    }, {});
  },

  async grantAccess(competitionId, userId, role) {
    const { data, error } = await supabase
      .from('competition_access')
      .upsert(
        {
          competition_id: competitionId,
          user_id: userId,
          role
        },
        { onConflict: 'competition_id,user_id' }
      )
      .select('competition_id, role');

    if (error) {
      console.error('Error granting access:', error);
      throw error;
    }

    // Log the action
    await auditLogService.logAction(
      'competition_access.granted',
      'competition',
      competitionId,
      null,
      { user_id: userId, role }
    );

    return data;
  },

  async updateAccess(competitionId, userId, role) {
    // Get old role for audit
    const { data: oldAccess } = await supabase
      .from('competition_access')
      .select('role')
      .match({ competition_id: competitionId, user_id: userId })
      .single();

    const { data, error } = await supabase
      .from('competition_access')
      .update({ role })
      .match({ competition_id: competitionId, user_id: userId });

    if (error) {
      console.error('Error updating access:', error);
      throw error;
    }

    // Log the action
    await auditLogService.logAction(
      'competition_access.role_changed',
      'competition',
      competitionId,
      { user_id: userId, role: oldAccess?.role },
      { user_id: userId, role }
    );

    return data;
  },

  async revokeAccess(competitionId, userId) {
    // Get old role for audit
    const { data: oldAccess } = await supabase
      .from('competition_access')
      .select('role')
      .match({ competition_id: competitionId, user_id: userId })
      .single();

    const { error } = await supabase
      .from('competition_access')
      .delete()
      .match({ competition_id: competitionId, user_id: userId });

    if (error) {
      console.error('Error revoking access:', error);
      throw error;
    }

    // Log the action
    await auditLogService.logAction(
      'competition_access.revoked',
      'competition',
      competitionId,
      { user_id: userId, role: oldAccess?.role },
      null
    );
  }
};
